(() => {
  let current = null;
  let activeTrigger = null;
  let scrollY = 0;
  let previousStyle = null;
  let index = 0;
  const focusable = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex="0"]';
  function closeMenu(restoreFocus = true) {
    if (!current) return;
    current.classList.remove('open');
    current.setAttribute('aria-hidden', 'true');
    current.inert = true;
    activeTrigger?.classList.remove('active');
    activeTrigger?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('superior-menu-open');
    Object.assign(document.body.style, previousStyle);
    window.scrollTo(0, scrollY);
    if (restoreFocus) activeTrigger?.focus({preventScroll:true});
    current = null;
  }
  function openMenu(trigger) {
    let panel = trigger.nextElementSibling;
    if (!panel?.matches('.full-menu-overlay')) panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    if (current === panel) { closeMenu(); return; }
    if (current) closeMenu(false);
    panel.id = 'superior-navigation-' + (++index);
    trigger.setAttribute('aria-controls', panel.id);
    activeTrigger = trigger;
    current = panel;
    document.body.append(panel);
    panel.inert = false;
    panel.classList.add('open');
    panel.setAttribute('aria-hidden', 'false');
    trigger.classList.add('active');
    trigger.setAttribute('aria-expanded', 'true');
    scrollY = window.scrollY;
    previousStyle = {position:document.body.style.position,top:document.body.style.top,left:document.body.style.left,right:document.body.style.right,width:document.body.style.width};
    Object.assign(document.body.style,{position:'fixed',top:-scrollY+'px',left:'0',right:'0',width:'100%'});
    document.body.classList.add('superior-menu-open');
    panel.querySelector('.overlay-menu').scrollTop = 0;
    panel.querySelector('.superior-menu-close')?.focus({preventScroll:true});
  }
  function applyView(value) {
    const view = value === 'single' ? 'single' : 'grid';
    document.querySelectorAll('#dT_collectionGrid').forEach(el => el.dataset.mobileView = view);
    document.querySelectorAll('[data-mobile-product-view]').forEach(btn => btn.setAttribute('aria-pressed',String(btn.dataset.mobileProductView === view)));
  }
  function init() {
    document.querySelectorAll('.full-menu-overlay:not(.open)').forEach(el=>{el.inert=true;el.setAttribute('aria-hidden','true');});
    let saved = 'grid';
    try { saved = localStorage.getItem('superior-mobile-product-view') || 'grid'; } catch {}
    applyView(saved);
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.button_container');
    if (trigger) { event.preventDefault();openMenu(trigger);return; }
    if (event.target.closest('.superior-menu-close')) { closeMenu();return; }
    if (current && event.target.closest('.full-menu-overlay a[href]')) closeMenu(false);
    const viewButton = event.target.closest('[data-mobile-product-view]');
    if (viewButton) {
      const value = viewButton.dataset.mobileProductView;
      applyView(value);
      try { localStorage.setItem('superior-mobile-product-view',value); } catch {}
    }
  });
  document.addEventListener('keydown',event=>{
    if (!current) return;
    if (event.key === 'Escape') { event.preventDefault();closeMenu(); }
    if (event.key === 'Tab') {
      const items = [...current.querySelectorAll(focusable)].filter(el=>el.getClientRects().length);
      const first = items[0], last = items[items.length-1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault();last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault();first?.focus(); }
    }
  });
  document.addEventListener('focusin',event=>{if(current&&!current.contains(event.target))current.querySelector('.superior-menu-close')?.focus({preventScroll:true});});
  const collectionRoot = document.querySelector('.main-collection-template');
  if(collectionRoot)new MutationObserver(records=>{if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1&&(node.matches?.('#dT_collectionGrid,.superior-product-view')||node.querySelector?.('#dT_collectionGrid,.superior-product-view')))))init();}).observe(collectionRoot,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',init);
  window.addEventListener('pagehide',()=>closeMenu(false));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();